import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';

class AddWordSelection extends React.PureComponent {
    render() {
        const { openAddWordSelection, elementTarget, closePopover, selectedText, changeSelectedTextToTrain } = this.props;

        return (
            <div className='popup'>
                <Popover
                    open={openAddWordSelection}
                    anchorEl={elementTarget}
                    onRequestClose={closePopover}
                    animation={PopoverAnimationVertical}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                >
                    <div className='popup-choose'>
                        <div className='chosen'>
                            <div className='chosen-title'>
                                Add text to train
                            </div>
                            <div className='chosen-row'>
                                {`'${selectedText}'`}
                            </div>
                            </div>

                            <div style={{ margin: '10px' }}>
                                <RaisedButton
                                    onClick={() => {
                                        changeSelectedTextToTrain(selectedText)
                                    }}
                                    primary
                                    label='Add or join'
                                 />
                        </div>
                    </div>
                </Popover>
            </div>
        );
    }
}

export default connect(
    (state, { openAddWordSelection, elementTarget, closePopover, selectedText, changeSelectedTextToTrain }) => {
        return {
            openAddWordSelection,
            elementTarget,
            closePopover,
            selectedText,
            changeSelectedTextToTrain,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(AddWordSelection);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Train/Content/AddSelectTextToTrain.jsx